'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/media/ContentfulImage.tsx
import { useCallback, useMemo } from "react";
import { ImageWithPlaceholder } from "@wbk/ui";
import { jsx } from "react/jsx-runtime";
var SRCSET_WIDTHS = [480, 800, 1280, 1920];
var ContentfulImage = (_a) => {
  var _b = _a, {
    format = "webp",
    fit,
    width,
    height,
    src,
    placeholder,
    sizes
  } = _b, props = __objRest(_b, [
    "format",
    "fit",
    "width",
    "height",
    "src",
    "placeholder",
    "sizes"
  ]);
  const isSvg = !!(src == null ? void 0 : src.endsWith(".svg"));
  const buildUrl = useCallback(
    (w, h) => {
      if (!src) return "";
      if (isSvg) return src.split("?")[0];
      const url = new URL(src);
      const base = `${url.origin}${url.pathname.replace(/,/g, "%2C")}`;
      const searchParams = new URLSearchParams(url.searchParams);
      if (format) searchParams.set("fm", format);
      if (fit) searchParams.set("fit", fit);
      if (typeof w === "number") searchParams.set("w", w.toString());
      if (typeof h === "number") searchParams.set("h", h.toString());
      return `${base}?${searchParams.toString()}`;
    },
    [src, isSvg, format, fit]
  );
  const newSrc = useMemo(() => buildUrl(width, height), [buildUrl, width, height]);
  const srcSet = useMemo(() => {
    if (isSvg || !/\.jpe?g$/i.test((src == null ? void 0 : src.replace(/\?.*/, "")) || "") || typeof width !== "number")
      return void 0;
    const ratio = typeof height === "number" ? height / width : null;
    return SRCSET_WIDTHS.filter((w) => w < width).concat(width).map((w) => `${buildUrl(w, ratio ? Math.round(w * ratio) : void 0)} ${w}w`).join(", ");
  }, [buildUrl, src, isSvg, width, height]);
  const Comp = placeholder ? ImageWithPlaceholder : "img";
  return /* @__PURE__ */ jsx(
    Comp,
    __spreadValues({
      src: newSrc,
      srcSet,
      sizes: srcSet ? sizes || "100vw" : sizes,
      width,
      height
    }, props)
  );
};
var ContentfulImage_default = ContentfulImage;

// src/components/media/ContentfulMedia.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ContentfulMediaComponent = (_a) => {
  var _b = _a, {
    media,
    placeholder,
    ref,
    poster
  } = _b, props = __objRest(_b, [
    "media",
    "placeholder",
    "ref",
    "poster"
  ]);
  var _a2;
  const video = media && ((_a2 = media == null ? void 0 : media.contentType) == null ? void 0 : _a2.includes("video"));
  if (video) {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      /* @__PURE__ */ jsx2(
        "video",
        __spreadProps(__spreadValues({
          poster,
          playsInline: true,
          disablePictureInPicture: true
        }, props), {
          className: `cursor-pointer ${props.className || ""}`,
          ref,
          children: /* @__PURE__ */ jsx2("source", { src: media.url, type: media.contentType })
        })
      )
    );
  }
  if (media && media.url.includes("youtube.com")) {
    return /* @__PURE__ */ jsx2(
      "iframe",
      {
        title: media.title,
        width: "100%",
        height: "100%",
        src: media.url,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        className: props.className
      }
    );
  }
  return /* @__PURE__ */ jsx2(
    ContentfulImage_default,
    __spreadValues({
      src: media == null ? void 0 : media.url,
      alt: media == null ? void 0 : media.title,
      width: media == null ? void 0 : media.width,
      height: media == null ? void 0 : media.height,
      placeholder
    }, props)
  );
};
var ContentfulMedia_default = ContentfulMediaComponent;

export {
  ContentfulImage_default,
  ContentfulMedia_default
};
//# sourceMappingURL=chunk-BYRNGPWN.mjs.map